/* eslint-disable */
import Constant from '@/configs/constant'
import router from '@/router'
import store from '@/store'
import LocalStorage from '@/utils/LocalStorage'
import UtilService from '@/utils/UtilService'
import { ethers } from 'ethers'
import * as walletConnect from '../../../connector/walletconnect'
import * as web3 from '../../../connector/web3'

const state = {
  initData: {
    connector: null,
    fetching: false,
    connected: false,
    chainId: 1,
    showModal: false,
    pendingRequest: false,
    uri: '',
    accounts: [],
    address: '',
    result: null,
    assets: []
  },
  bridgeConnector: {
    bridge: null,
    qrcodeModal: null
  },
  account: {},
  assets: {},
  web3: {},
  ethereum: {},
  selectedAddress: '',
  provider: null,
  isConnected: false
}

const getters = {
  pendingRequest: state => state.initData.pendingRequest,
  web3: state => state.web3,
  ethereum: state => state.ethereum,
  bridgeConnector: state => state.bridgeConnector,
  account: state => state.account,
  selectedAddress: state => state.selectedAddress,
  isConnected: state => state.isConnected
}

const mutations = {
  SET_SYS_CONFIG: (state, data) => {
    state.configs = data
    state.reCaptchaV3Key = data.reCaptchaV3Key
  },
  SET_WEB3: (state, data) => {
    state.web3 = data
  },
  SET_ETHEREUM: (state, data) => {
    state.ethereum = data
  },
  SET_ACCOUNT: (state, data) => {
    state.account = data
  },
  SET_ADDRESS: (state, data) => {
    state.selectedAddress = data
  },
  setIsConnected: (state, status) => {
    state.isConnected = status
  }
}

const actions = {
  handleConnectWallet: async ({ state, dispatch }, type) => {
    if(type === Constant.TYPES_CONNECT.INJECT) {
      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' })
      if(accounts[0]) {
        web3.listenEvent()
        dispatch('connectedWallet', {
          type,
          account: accounts[0]
        })
      }
    } else {
      const config = state.configs
      const data = await walletConnect.connect(config.bscChainId)
      if(data.status) {
        const account = data.address
        dispatch('connectedWallet', {
          type,
          account
        })
      }
    }
  },
  connectedWallet: ({commit, dispatch}, {type, account}) => {
    state.account = account
    localStorage.setItem(Constant.LOCAL_STORE.CONNECTED_TYPE, type)
    localStorage.setItem(Constant.LOCAL_STORE.IS_CONNECTED, true)
    commit('SET_ADDRESS', account)
    dispatch('toggleWalletProviderForm', false)
    commit('setIsConnected', true)
  },
  getAccountConnect: async ({dispatch, state}) => {
    let _connectType = localStorage.getItem(Constant.LOCAL_STORE.CONNECTED_TYPE)
    if(!_connectType) return
    _connectType = _connectType * 1
    if(_connectType  === Constant.TYPES_CONNECT.INJECT) {
      if(!window) return
      const accounts = await window.ethereum.request({ method: 'eth_accounts' })
      if(accounts.length > 0) {
        const _isConnected = localStorage.getItem(Constant.LOCAL_STORE.IS_CONNECTED)
        if(_isConnected === 'true') {
          state.account === accounts[0]
          dispatch('connectedWallet', {
            type: _connectType,
            account: accounts[0]
          })
        }
      }
    } else {
      const _walletConnect = localStorage.getItem('walletconnect')
      if(_walletConnect) {
        const connector = await walletConnect.connect(state.configs.bscChainId)
        if(connector.status) {
          const account = connector.address
          dispatch('connectedWallet', {
            type: _connectType,
            account
          })
        }
      }
    }
    return _connectType
  },
  setAccount({ commit }, data) {
    commit('SET_ACCOUNT', data)
  },
  disconnect ({commit}) {
    const typeStr = localStorage.getItem(Constant.LOCAL_STORE.CONNECTED_TYPE)
    if(typeStr) {
      const type = typeStr * 1
      if(type === Constant.TYPES_CONNECT.WALLET_CONNECT) {
        walletConnect.disconnect()
        window._provider = null
      }
    }
    localStorage.removeItem(Constant.LOCAL_STORE.CONNECTED_TYPE)
    localStorage.removeItem(Constant.LOCAL_STORE.IS_CONNECTED)
    commit('setIsConnected', false)
  },
  async switchChain ({__}, chainId) {
    const hexStr = '0x' + chainId.toString(16)
    await ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: hexStr }],
   })
  },
  logout () {
    LocalStorage.removeToken()
    this.dispatch('setJwt', null)
    this.dispatch('setAccount', {})
    router.push({ name: 'landing' })
    try {
      connectorEvents.logout()
    } catch (error) {
    }
    LocalStorage.removeWalletConnect()
  },
  async sendTransaction ({state}, params) {
    try {
      const { amount, address: toAddress, currency, contract} = params
      const providerInject = window._provider || window.ethereum
      if (!providerInject) return
      const provider = new ethers.providers.Web3Provider(providerInject)
      const signer = await provider.getSigner()
      const address = state.account

      // from
      const from = address
      // to
      const to = toAddress
      const toErc20Address = UtilService.removeTokenPrefix(to)
      const _nonce = await provider.getTransactionCount(address)
      const nonce = UtilService.sanitizeHex(UtilService.convertStringToHex(_nonce))

      const gasPrices = await provider.getGasPrice()
      // data
      const transferAction = Constant.RPC_URL_ACTION.TRANSFER
      const amountDecimal = UtilService.convertAmountToRawNumber(amount, 18)
      const hexAmountStr = UtilService.convertStringToHex(amountDecimal)
      const dataAmount = UtilService.removeTokenPrefix(hexAmountStr)
      const data = transferAction + UtilService.addAddressPrefix(toErc20Address)  + UtilService.addAddressPrefix(dataAmount)
      const rawTx = {
        from,
        to: contract,
        nonce,
        gasPrice: UtilService.multipliedBy(gasPrices.toString(), 1),
        gasLimit: 150000,
        value: '0x0',
        data
      }
      try {
        const result = await signer.sendTransaction(rawTx)
        const body = {
          address: from,
          amount: amount,
          hash: result.hash,
          symbol: currency
        }
        store.dispatch('toggleDepositForm')
        store.dispatch('toggleDepositSuccessForm', body)
      } catch (error) {
        store.dispatch('showErrorMsg', 'Action refused')
      }
    } catch {
      store.dispatch('showErrorMsg', 'System error')
    }
  }
}

export default { state, getters, mutations, actions }
